
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";
import { ParteProps } from "./ParteInterface";

// Definición de defaults

export const defaultIrregular: IrregularProps = { 
    idIrregular: 0, 
    numeroIrregular: '', 
    numeroExpediente: '',   
    idEstatus: 0,  
    estatus: '', 
    idJuzgadoOrigen: 0,
    juzgadoOrigen: '', 
    idJuez: 0,
    juez: '', 
    idSecretario: 0,
    secretario: '', 
    idEtapa: 0,
    etapa: '',
    idSubEtapa: 0,
    subEtapa: '',
    digitalizacion: '',
    partes: [],
    actores: [], 
    demandados: [], 
    caratula: '',
}

export const defaultIrregularResponse: BuscarIrregularResponse = {
    ...defaultHttpResponse,
    ...defaultIrregular,
};

export const defaultGenerarCaratulaIrregular: GenerarCaratulaIrregularResponse = {
    ...defaultHttpResponse,
    caratula: '',
};

// Creación de interfaces

export interface IrregularProps {
    idIrregular:      number;
    numeroIrregular:  string;
    numeroExpediente: string;
    idJuez:           number;
    juez:             string;
    idSecretario:     number;
    secretario:       string;
    idJuzgadoOrigen:  number;
    juzgadoOrigen:    string;
    idEstatus:        number;
    estatus:          string;
    idEtapa:          number;
    etapa:            string;
    idSubEtapa:       number;
    subEtapa:         string;
    digitalizacion:   string;
    fecha?:           Date;
    partes:           ParteProps[];
    actores:          string[];
    demandados:       string[];
    caratula:         string;
}

export interface BuscarIrregularParams {
    numeroIrregular:   string;
    idAutoridad:       number;
}

export interface BuscarIrregularResponse extends HttpResponse, IrregularProps { }

export interface GenerarCaratulaIrregularResponse {
    success:        boolean;
    message:        string;
    caratula:       string;
}

export interface AgregarPartesIrregularParams {
    idIrregular:    number;
    partes:         ParteProps[];
}
